<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'BuildUserCountStat',
  props: {
    title: {
      type: String,
      default: '建筑修复总数'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#1E90FF', '#7B68EE', '#BA55D3'],
        title: {
          text: '建筑修复人数'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['建筑人数', '修复人数'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '建筑人数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '修复人数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
    },
    refresh(data) {
      const time = []
      const build = []
      const fixes = []
      for (const i in data) {
        time.push(dateStrTodate(data[i].date))
        build.push(data[i].build_user)
        fixes.push(data[i].fixes_user)
      }
      this.option.xAxis.data = time
      this.option.series[0].data = build
      this.option.series[1].data = fixes
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
